var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('ListView',{staticClass:"page-financing",attrs:{"headline":_vm.trans.get('cockpit.pages.disbursed.headline'),"tableData":_vm.tableData,"isDownload":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }